var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlcoholSmoking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6305",
    "data-name": "Group 6305",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.806,
    height: 79.487,
    viewBox: "0 0 54.806 79.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5185",
    "data-name": "Rectangle 5185",
    width: 54.806,
    height: 79.487,
    fill: "#31b2cf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6304",
    "data-name": "Group 6304",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22744",
    "data-name": "Path 22744",
    d: "M20.7,26.928c-.335-.784-.708-1.551-1.065-2.326a23.286,23.286,0,0,1-2.272-9.893c.007-3.8-.048-7.609,0-11.412A3.034,3.034,0,0,0,15.378,0H9.32A3.1,3.1,0,0,0,7.43,3.351c.088,3.492.025,6.987.027,10.48a23.2,23.2,0,0,1-1.572,8.955C4.862,25.269,3.707,27.7,2.574,30.135A26.529,26.529,0,0,0,0,41.458Q.012,58.5,0,75.54a3.692,3.692,0,0,0,4,3.943q6.872.007,13.745,0c.252,0,.5-.021.79-.034v-2.4H17.65q-6.833,0-13.667,0c-1.116,0-1.541-.432-1.547-1.55-.007-1.165,0-2.329,0-3.494V68.28H17.923V65.853H2.493V43.44h15.42V41.005H2.509c0-.614-.043-1.154.007-1.686A26.037,26.037,0,0,1,4.842,31c1.349-2.987,2.728-5.971,3.852-9.045a43.067,43.067,0,0,0,1.285-5.785H14.9c.036.2.083.374.1.551A30.29,30.29,0,0,0,18.48,27.9a1.26,1.26,0,0,0,1.7.756,1.229,1.229,0,0,0,.517-1.728M14.855,13.636H9.94V7.464h4.915Zm.012-8.69H9.936V2.508h4.931Z",
    transform: "translate(0)",
    fill: "#31b2cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22745",
    "data-name": "Path 22745",
    d: "M163.714,208.076q0-20.693,0-41.385c0-1.531-.318-1.838-1.878-1.838h-1.848c0-1.189,0-2.295,0-3.4-.006-1.16-.425-1.568-1.6-1.57q-1.941,0-3.883,0c-1.61,0-1.915.3-1.915,1.88,0,1,0,2,0,3.089h-1.146q-10.446,0-20.891,0c-1.138,0-1.571.417-1.571,1.523q0,23.294,0,46.588c0,1.085.427,1.526,1.486,1.527q15.882,0,31.764,0c1.062,0,1.483-.439,1.487-1.525.006-1.63,0-3.261,0-4.892m-3.675-40.755h1.175v7.422h-1.175Zm-5-4.942h2.516v.777c0,3.206-.088,6.416.029,9.618a23.447,23.447,0,0,1-.981,6.938c-.325,1.222-.606,2.455-.932,3.676a8.151,8.151,0,0,1-.41,1l-.222-.083Zm-4.929,4.952h2.425V184.7h-2.425Zm-18.651.012H147.57v2.48c-1.155,0-2.284,0-3.412,0-1.075.006-1.507.433-1.514,1.5-.007,1.129,0,2.259,0,3.428H131.457Zm16.11,17.361h-2.434V172.322h2.434Zm-4.984-.013H140.15v-7.413h2.434Zm-4.969-7.441v7.073l-.229.054c-.833-2.288-1.224-4.7-1.914-7.127Zm-6.167.023h1.525c.528,2.1,1.067,4.191,1.581,6.291.66,2.7,1.795,3.6,4.586,3.6q7.373,0,14.746,0a3.747,3.747,0,0,0,4.133-3.177c.575-2.224,1.126-4.454,1.7-6.717h1.515v12.39H131.448Zm-.008,14.925h29.8v13.6h-29.8Zm29.807,19.8H131.456v-3.659h29.789Z",
    transform: "translate(-108.909 -135.009)",
    fill: "#31b2cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22746",
    "data-name": "Path 22746",
    d: "M0,6.172Z",
    transform: "translate(9.94 7.464)",
    fill: "#31b2cf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholSmoking);
export default __webpack_public_path__ + "static/media/alcohol-smoking.09a638c8cb9f3bdd99282f23dddb2d6c.svg";
export { ForwardRef as ReactComponent };